import React from 'react'
import AppNavbar from '../components/Navbar/Navbar'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'

const ContactPage = () => {
  return (
    <div>
        <AppNavbar/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default ContactPage